import React from 'react';
import ScorecardWidgetBuilder from './ScorecardWidgetBuilder';
import ScorecardWidgetRenderer from './ScorecardWidgetRenderer';
import Preview from './Preview';
import Summary from './Summary';
import type { WidgetDefinition } from '../../../registry';
import type { ScorecardWidgetConfig, ScorecardDataContent } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';

export { default as ScorecardWidgetBuilder } from './ScorecardWidgetBuilder';
export { default as ScorecardWidgetRenderer } from './ScorecardWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'scorecard',
  meta: {
    label: 'Scorecard',
    icon: React.createElement(FontAwesomeIcon, { icon: faClipboardList }),
    description: 'Rate items on a 5-point scale from -- to ++',
    isSystem: true,
    isCreatable: false,
    shareable: true,
    dataFlow: 'input',
    summaryEligible: true,
    lastUpdated: '2026-04-06',
  },
  defaultSize: { w: 2, h: 2, minW: 2, minH: 2 },
  defaultConfig: () => ({
    showLabels: true,
    layout: 'carousel',
  } as ScorecardWidgetConfig),
  Builder: ScorecardWidgetBuilder,
  Renderer: ScorecardWidgetRenderer,
  Preview,
  Summary,
  sampleSummaryData: [
    { score: '++' },
    { score: '+' },
    { score: '=' },
    { score: '-' },
    { score: '--' },
    undefined,
  ],
  validate: (data: unknown): string[] => {
    const scoreData = data as ScorecardDataContent | undefined;
    if (!scoreData?.score) {
      return ['A score selection is required'];
    }
    return [];
  },
};
